module.exports = __webpack_public_path__ + "static/media/no-courses.ddc8322b.svg";